import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { AiFillDashboard, AiFillHome } from "react-icons/ai";
import { TbArticleFilledFilled } from "react-icons/tb";
import { OBPSService } from "../../../../../../libraries/src/services/elements/OBPS";
import { useSelector } from "react-redux";
import DashboardAccordion from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/DashboardAccordion";
import { BiSolidReport } from "react-icons/bi";
// import { OBPSService } from "@egovernments/digit-ui-libraries/src/services/elements/OBPS";

const ToolTipWrapper = ({ child, label, t }) => (
  <span className="tooltip">
    {child}
    <span className="tooltiptext" style={{ fontSize: "14px", marginLeft: "0px", bottom: "20%" }}>
      <div style={{ background: "#555", width: "100%", padding: "5px", borderRadius: "6px", whiteSpace: "pre" }}>{t(label)}</div>
    </span>
  </span>
);

const useStyles = makeStyles((theme) => ({
  accordion: {
    // backgroundColor: "#2A3F54",
    backgroundColor: "transparent",
    padding: "0",
    boxShadow: "none",
    margin: "0!important",
    "&:hover": {
      background: "#64a3c9",
      color: "#000",
      borderRadius: "0px",
    },
    // marginBottom: "8px",
    // borderRadius: "10px",
  },
  accordionDetails: {
    // backgroundColor: "#4A5D73",
    display: "flex",
    flexDirection: "column",
    margin: "0px",
    padding: "0px",
  },
  accordionSummary: {
    // backgroundColor: "#2A3F54",
    backgroundColor: "transparent",
    margin: "10px 0px!important",

    minHeight: "100%!important",
    "&:hover": {
      background: "#64a3c9",
      color: "#000",
    },

    // borderRadius: "10px",
  },
  divider: {
    background: theme.palette.divider,
  },

  accordionHeader: {
    display: "flex",
    // justifyContent: "space-evenly",
    fontSize: "13px",
    // fontWeight: "300",
    color: "#fff",
    // display: "flex",
    alignItems: "center",
    "& svg": {
      fontSize: "17px",
    },
  },

  accordionLink: {
    fontSize: "13px",
    // marginBottom: "8px",
    color: "#fff",
    textDecoration: "none",
    textDecorationLine: "none",
    "&:hover": {
      duration: 1,
      color: "#ccc",
      display: "block",
      textDecoration: "none",
      fontSize: "13px",
      // backgroundColor: "#4A5D73",
    },
    "&.active": {
      color: "#003366", // Deeper blue shade for the active link
    },
  },
}));

const EmployeeSideBar = ({ mobileView }) => {
  const classes = useStyles();
  const { businessServices, tenantIds, count, officerRole } = useSelector((state) => state.empInbox);
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  const ADMIN = Digit.Utils.hrmsAccess();
  const SUPERUSER = Digit.Utils.superUserAccess();
  const FINANCE_CONTROLLER = Digit.Utils.financeController();
  const tenantId = userDetails?.tenantId;
  console.log(SUPERUSER, "superuser", ADMIN);
  console.log("userDetailsSideBarEmp", userDetails, businessServices, tenantId, count, officerRole);

  const [SSODashUrl, setSSODashUrl] = useState("");
  const [dashboardData, setDashBoardData] = useState({});
  const [nocDashboardData, setNocDashboardData] = useState({}); // NEW STATE
  const [ltpData, setLtpData] = useState([]);
  const STADMIN = Digit.UserService.hasAccess("STADMIN");
  const NATADMIN = Digit.UserService.hasAccess("NATADMIN");

  let key = "ACTION_TEST_HOME";
  let ke = "ACTION_TEST_TRACTKER";
  let keynotification = "ACTION_TEST_NOTIFICATION";
  let notification = "ACTION_TEST_CREATE_NOTIFICATION";

  if (STADMIN) {
    key = "ACTION_TEST_SURE_DASHBOARD";
  }
  if (STADMIN) {
    ke = "ACTION_TEST_SURE_DASHBOARD";
  }
  if (STADMIN) {
    keynotification = "ACTION_TEST_SURE_DASHBOARD";
  }
  if (STADMIN) {
    notification = "ACTION_TEST_SURE_DASHBOARD";
  }
  if (NATADMIN) {
    key = "ACTION_TEST_NATDASHBOARD";
  }
  if (NATADMIN) {
    ke = "ACTION_TEST_NATDASHBOARD";
  }
  if (NATADMIN) {
    keynotification = "ACTION_TEST_NATDASHBOARD";
  }
  if (NATADMIN) {
    notification = "ACTION_TEST_NATDASHBOARD";
  }

  function getRedirectionUrl() {
    if (NATADMIN) return "/digit-ui/employee/payment/integration/dss/NURT_DASHBOARD";
    else if (STADMIN) return "/employee/integration/dss/home";
    else return SSODashUrl;
  }
  const roleToFormTypesMap = {
    JE: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION"],
    AE: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION"],
    EE: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION"],
    CTP: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION"],
    TP: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION"],
    Vice_Chairman: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION"],
    Additional_Secretory: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION"],
    Additional_Secretary: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION"],
    Secretory: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION"],
    Secretary: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION"],
    BPA_SURVEYOR: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION"],
    ASSOCIATE_JE: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION"],
    Authorized_Officer: ["FORM_LANDUSE"],
    DRAFTSMAN: ["FORM_LANDUSE"],
    APA: ["FORM_LANDUSE", "FORM_PURCHASABLE_FAR", "FORM_MAP"],
    CAP: ["FORM_LANDUSE", "FORM_PURCHASABLE_FAR", "FORM_MAP"],
    ATP: ["FORM_LANDUSE", "FORM_PURCHASABLE_FAR", "FORM_MAP"],
    AP: ["FORM_LANDUSE", "FORM_PURCHASABLE_FAR", "FORM_MAP"],
    HC: ["FORM_LANDUSE", "FORM_PURCHASABLE_FAR", "FORM_MAP"],
    AAP: ["FORM_LANDUSE", "FORM_PURCHASABLE_FAR", "FORM_MAP"],
    Acquisition_Section_Incharge: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    Nazul_Section_Incharge: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    Improvement_Trust_Incharge: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    Property_Section_Incharge: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    Urban_Ceiling_Incharge: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    Tehsildar: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    AAI_General_Manager: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    Army_Airforce_Station_Officer: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    Fire_Chief_Officer: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    Irrigation_Executive_Officer: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    UPMRC_MD: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    Forest_District_Officer: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    Railways_Section_Engineer: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    Power_Executive_Engineer: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    NHAI_Project_Director: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    PWD_Executive_Engineer: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    ASI_Superintendent: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    Jail_Superintendent: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    ULB_Nagar_Aayukt: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    Environment_UPPCB_Secretary: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    Security_ADG: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
    UPAVP_Chief_Architect: ["FORM_NOC", "FORM_MAP", "FORM_LANDUSE"],
  };

  const isNocModule = userDetails?.organisationName === "noc-services";
  const hasAuthorizedRoles = officerRole?.some((role) => role.code === "NODAL_OFFICER_AWAS" || role.code === "Nodal Officer");
  const authorizedOfficer = officerRole?.some((role) =>
    [
      "Authorized_Officer",
      "DRAFTSMAN",
      "APA",
      "CAP",
      "AP",
      "AAP",
      "HC",
      "EE",
      "ATP",
      "TP",
      "CTP",
      "Additional_Secretory",
      "Additional_Secretary",
      "Vice_Chairman",
      "Secretory",
      "Secretary",
      "BPA_SURVEYOR",
      "ASSOCIATE_JE",
      "JE",
      "AE",
    ].includes(role.code)
  );
  const excludedRoles = [
    "Authorized_Officer",
    "DRAFTSMAN",
    "APA",
    "Acquisition_Section_Incharge",
    "NODAL_OFFICER_AWAS",
    "Nodal Officer",
    "HRMS_ADMIN",
    "SUPERUSER",
    "EMPLOYEE_ADMIN",
    "FINANCE_CONTROLLER",
  ];

  const showMapSub = !officerRole?.some((role) => excludedRoles.includes(role.code));
  const getFormType = (roleCode) => {
    return roleToFormTypesMap[roleCode] || [];
  };
  const roleCode = officerRole?.[0]?.code;
  const formTypes = useMemo(() => getFormType(roleCode), [roleCode]);
  // const formTypes = useMemo(() => getFormType(officerRole?.[0]?.code), [officerRole]);
  console.log("calculatedFormTypes", formTypes);

  // const tenantId = Digit.ULBService.getCurrentTenantId();
  const fetchData = async () => {
    console.log("insideFetchDataUseEffect");
    const result = await OBPSService.InboxSearchApplication(tenantId, { formType: "MAP_SUB" });
    console.log("logginFromSidebar1", result);

    setDashBoardData(result);
  };
  const fetchLtpData = async () => {
    const data = await OBPSService.InboxSearchApplicationProfessional(tenantId, {});
    console.log("logginFromSidebar2", data);
    setLtpData(data);
  };
  const fetchAllFormTypesData = async () => {
    const allInboxResults = {};
    const allNocResults = {};
    console.log("fromFetchAllFormTypesData", formTypes, isNocModule);

    for (const formType of formTypes) {
      try {
        if (isNocModule) {
          const [nocResult, inboxResult] = await Promise.all([
            OBPSService.NOCCountSearch(tenantId, {
              applicationType: "FORM_NOC",
            }),
            OBPSService.InboxSearchApplication(tenantId, {
              applicationType: formType,
            }),
          ]);
          allNocResults[formType] = nocResult;
          allInboxResults[formType] = inboxResult;
        } else {
          const inboxResult = await OBPSService.InboxSearchApplication(tenantId, {
            // countDate: "2025",
            applicationType: formType,
          });
          allInboxResults[formType] = inboxResult;
        }
      } catch (error) {
        console.error(`Error fetching for ${formType}`, error);
        allInboxResults[formType] = [];
        if (isNocModule) allNocResults[formType] = [];
      }
    }
    setDashBoardData(allInboxResults);
    if (isNocModule) setNocDashboardData(allNocResults);
  };

  useEffect(() => {
    setSSODashUrl(localStorage.getItem("ssoDashboardURL"));
    if (officerRole?.[0]?.code === "Nodal Officer" || officerRole?.[0]?.code === "NODAL_OFFICER_AWAS") {
      fetchLtpData();
    }
    if (formTypes.length > 0 && officerRole?.[0]?.code != "Nodal Officer") {
      fetchAllFormTypesData();
    }
    // fetchData();
    // pvtfetchData();
  }, [roleCode, tenantId]);
  const { t } = useTranslation();
  console.log(dashboardData, "dashboardDataaa");

  return (
    <div className="sidebar">
      <div className="sidebar-sec-logo">
        <img className="state" src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg" />
        <h3>FASTPAS</h3>
      </div>
      {/* <Link to="/digit-ui/employee">
        <div className="actions active">
          <ToolTipWrapper
            child={
              <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" fill="white" />
              </svg>
            }
            t={t}
            label={"ACTION_TEST_HOME"}
          />
        </div>
      </Link> */}
      {/* <Accordion className={classes.accordion}>
        <AccordionSummary aria-controls="manage-application-content" id="manage-application-header" className={classes.accordionSummary}>
          <Link to="/digit-ui/employee">
            <Typography className={classes.accordionHeader}>
              <span style={{ marginRight: "3px" }}>
                <AiFillDashboard />
              </span>{" "}
              Dashboard
            </Typography>
          </Link>
        </AccordionSummary>
      </Accordion> */}
      {(ADMIN || SUPERUSER) && (
        <div className="without-dropdown">
          <a href="/digit-ui/employee">
            <div className={classes.accordionHeader}>
              <span style={{ marginRight: "5px" }}>
                <AiFillHome />
              </span>{" "}
              Home
            </div>
          </a>
        </div>
      )}
      {
        <div className="without-dropdown">
          <a href="/digit-ui/employee/obps/dashboard-details">
            <div className={classes.accordionHeader}>
              <span style={{ marginRight: "5px" }}>
                <AiFillDashboard />
              </span>{" "}
              {t("FASTPAS.DASHBOARD.MAIN.TEXT")}
            </div>
          </a>
        </div>
      }
      {/* <DashboardAccordion
        title={"Dashboard"}
        icon={<AiFillDashboard />}
        formTypes={formTypes}
        classes={classes}
        linkTo="/digit-ui/employee/obps/dashboard-details"
        isAccordion={false} // This will make it clickable without expanding
      /> */}
      {/* <DashboardAccordion
        title={<React.Fragment>Received Files {count && <span>&nbsp;({count})</span>}</React.Fragment>}
        icon={<AiFillDashboard />}
        formTypes={formTypes}
        classes={classes}
        linkTo="/digit-ui/employee"
        isAccordion={false}
      /> */}
      {!(ADMIN || SUPERUSER || FINANCE_CONTROLLER) && (
        <div className="without-dropdown">
          <a href="/digit-ui/employee">
            <div className={classes.accordionHeader}>
              <span style={{ marginRight: "5px" }}>
                <AiFillDashboard />
              </span>{" "}
              Received Files {count && <span> ({count})</span>}
            </div>
          </a>
        </div>
      )}
      {/* <Accordion className={classes.accordion}>
        <AccordionSummary aria-controls="manage-application-content" id="manage-application-header" className={classes.accordionSummary}>
          <Link to="/digit-ui/employee">
            <Typography className={classes.accordionHeader}>
              <span style={{ marginRight: "3px" }}>
                <AiFillDashboard />
              </span>{" "}
              Received Files {count && <span> ({count})</span>}
            </Typography>
          </Link>
        </AccordionSummary>
      </Accordion> */}

      {hasAuthorizedRoles && !authorizedOfficer && (
        <DashboardAccordion
          title={"Licensed Technical Professional"}
          icon={<TbArticleFilledFilled />}
          formTypes={formTypes}
          dashboardData={ltpData}
          classes={classes}
          // currentFormType={"NEW"}
        />
      )}

      {isNocModule && (
        <DashboardAccordion
          title={"NOC Applications"}
          icon={<TbArticleFilledFilled />}
          formTypes={formTypes}
          dashboardData={nocDashboardData}
          classes={classes}
          currentFormType={"FORM_NOC"}
        />
      )}
      {authorizedOfficer && (
        <DashboardAccordion
          title={t("FASTPAS.GLOBAL.LAND.USE.VER.TEXT")}
          icon={<TbArticleFilledFilled />}
          formTypes={formTypes}
          dashboardData={dashboardData}
          classes={classes}
          currentFormType={"FORM_LANDUSE"}
        />
      )}
      {/* {showMapSub && (
        <DashboardAccordion
          title={"Purchasable FAR"}
          icon={<TbArticleFilledFilled />}
          formTypes={formTypes}
          dashboardData={dashboardData}
          classes={classes}
          currentFormType={"FORM_PURCHASABLE_FAR"}
        />
      )} */}
      {showMapSub && (
        <DashboardAccordion
          title={t("FASTPAS.GLOBAL.MAP.SUBMISSION.TEXT")}
          icon={<TbArticleFilledFilled />}
          formTypes={formTypes}
          dashboardData={dashboardData}
          classes={classes}
          currentFormType={"FORM_MAP"}
        />
      )}
      {showMapSub && (
        <DashboardAccordion
          title={"Purchasable FAR"}
          icon={<TbArticleFilledFilled />}
          formTypes={formTypes}
          dashboardData={dashboardData}
          classes={classes}
          currentFormType={"FORM_PURCHASABLE_FAR"}
        />
      )}

      {showMapSub && (
        <DashboardAccordion
          title={t("FASTPAS.GLOBAL.PLINTH.SUB.TEXT")}
          icon={<TbArticleFilledFilled />}
          formTypes={formTypes}
          dashboardData={dashboardData}
          classes={classes}
          currentFormType={"FORM_PLINTH"}
        />
      )}

      {showMapSub && (
        <DashboardAccordion
          title={t("Completion")}
          icon={<TbArticleFilledFilled />}
          formTypes={formTypes}
          dashboardData={dashboardData}
          classes={classes}
          currentFormType={"FORM_COMPLETION"}
        />
      )}
      {/* <Accordion className={classes.accordion}>
        <AccordionSummary aria-controls="manage-application-content" id="manage-application-header">
          <Link to='/digit-ui/employee/obps/self-certification-details'>
            <Typography className={classes.accordionHeader}><span style={{marginRight: '3px'}}><TbArticleFilledFilled /></span>Self Approval Reports</Typography>
          </Link>
        </AccordionSummary>
      </Accordion> */}

      {/* MIS Reports Accordion */}

      <div className="without-dropdown">
        <a href="/digit-ui/employee/obps/mis-reports">
          <div className={classes.accordionHeader}>
            <span style={{ marginRight: "5px" }}>
              <BiSolidReport />
            </span>{" "}
            MIS Reports
            {/* {count && <span> ({count})</span>} */}
          </div>
        </a>
      </div>

      {/* <Accordion className={classes.accordion}>
        <AccordionSummary expandIcon={<ExpandMore style={{ color: "white" }} />} aria-controls="mis-reports-content" id="mis-reports-header">
          <Typography className={classes.accordionHeader}>
            <span style={{ marginRight: "3px" }}>
              <BiSolidReport />
            </span>{" "}
            MIS Reports
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{ display: "flex", flexDirection: "column", backgroundColor: "#225785" }}>
          <Link to="/digit-ui/employee/obps/mis-reports" className={classes.accordionLink} activeClassName="active">
            MIS Reports
          </Link>
          <Divider />
        </AccordionDetails>
      </Accordion> */}

      {/* 
      <Link to="/digit-ui/employee">
        <div className="actions active">
          <ToolTipWrapper
            child={
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 10H8V0H0V10ZM0 18H8V12H0V18ZM10 18H18V8H10V18ZM10 0V6H18V0H10Z" fill="white" />
                </svg>
            }
            t={t}
            label={"ACTION_TEST_NOTIFICATION"}
          />
        </div>
      </Link> */}
      {/* <a href={keynotification.includes("DASHBOARD") ? `/employee/integration/dss/${NATADMIN ? "NURT_DASHBOARD" : "NOTIFICATION"}` : "/digit-ui/employee"}>
        <div className="actions">
          <ToolTipWrapper
            child={
              keynotification.includes("DASHBOARD") ? (
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 10H8V0H0V10ZM0 18H8V12H0V18ZM10 18H18V8H10V18ZM10 0V6H18V0H10Z" fill="white" />
                </svg>
              ) : (
                
                 <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg" title="National DSS Tractker">
    <path
      d="M8 20C9.1 20 10 19.1 10 18H6C6 19.1 6.89 20 8 20ZM14 14V9C14 5.93 12.36 3.36 9.5 2.68V2C9.5 1.17 8.83 0.5 8 0.5C7.17 0.5 6.5 1.17 6.5 2V2.68C3.63 3.36 2 5.92 2 9V14L0 16V17H16V16L14 14Z"
      fill="white"
    />
  </svg>
              )
            }
            t={t}
            label={keynotification}
          />
        </div>
      </a>} */}

      {/* <a href={notification.includes("DASHBOARD") ? `/employee/integration/dss/${NATADMIN ? "NURT_DASHBOARD" : "CREATE"}` : "/digit-ui/employee"}>
        <div className="actions">
          <ToolTipWrapper
            child={
              notification.includes("DASHBOARD") ? (
                <svg xmlns="http://www.w3.org/2000/svg" title="National DSS Tractker" width="16" height="16" fill="currentColor" class="bi bi-envelope-paper-fill" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M6.5 9.5 3 7.5v-6A1.5 1.5 0 0 1 4.5 0h7A1.5 1.5 0 0 1 13 1.5v6l-3.5 2L8 8.75l-1.5.75ZM1.059 3.635 2 3.133v3.753L0 5.713V5.4a2 2 0 0 1 1.059-1.765ZM16 5.713l-2 1.173V3.133l.941.502A2 2 0 0 1 16 5.4v.313Zm0 1.16-5.693 3.337L16 13.372v-6.5Zm-8 3.199 7.941 4.412A2 2 0 0 1 14 16H2a2 2 0 0 1-1.941-1.516L8 10.072Zm-8 3.3 5.693-3.162L0 6.873v6.5Z"/>
              </svg>
                // <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                //   <path d="M0 10H8V0H0V10ZM0 18H8V12H0V18ZM10 18H18V8H10V18ZM10 0V6H18V0H10Z" fill="white" />
                // </svg>
              ) : (
                
                <svg xmlns="http://www.w3.org/2000/svg" title="National DSS Tractker" width="16" height="16" fill="currentColor" class="bi bi-envelope-paper-fill" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M6.5 9.5 3 7.5v-6A1.5 1.5 0 0 1 4.5 0h7A1.5 1.5 0 0 1 13 1.5v6l-3.5 2L8 8.75l-1.5.75ZM1.059 3.635 2 3.133v3.753L0 5.713V5.4a2 2 0 0 1 1.059-1.765ZM16 5.713l-2 1.173V3.133l.941.502A2 2 0 0 1 16 5.4v.313Zm0 1.16-5.693 3.337L16 13.372v-6.5Zm-8 3.199 7.941 4.412A2 2 0 0 1 14 16H2a2 2 0 0 1-1.941-1.516L8 10.072Zm-8 3.3 5.693-3.162L0 6.873v6.5Z"/>
              </svg>
              )
            }
            t={t}
            label={notification}
          />
        </div>
      </a>

      <a href={ke.includes("DASHBOARD") ? `/employee/integration/dss/${NATADMIN ? "NURT_DASHBOARD" : "TRACTKER"}` : "/digit-ui/employee"}>
        <div className="actions">
          <ToolTipWrapper
            child={
              ke.includes("DASHBOARD") ? (
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 10H8V0H0V10ZM0 18H8V12H0V18ZM10 18H18V8H10V18ZM10 0V6H18V0H10Z" fill="white" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" title="National DSS Tractker">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
                    fill="white"
                  />
                </svg>
              )
            }
            t={t}
            label={ke}
          />
        </div>
      </a> */}
    </div>
  );
};

export default EmployeeSideBar;
